import { WarningKey } from "@silo/types";
import { cn } from "../../utils/class-names";
import { match } from "ts-pattern";
import { PlainLink } from "../link";

interface DescriptionProps {
  className?: string;
  warningKey: WarningKey;
  variant: "tooltip" | "banner";
}

export function Description({
  className,
  warningKey,
  variant,
}: DescriptionProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col gap-2.5",
        match(variant)
          .with("tooltip", () => "text-shale-100")
          .with("banner", () => "text-shale-200")
          .exhaustive(),
        className
      )}
    >
      {match(warningKey)
        .with("UWU", () => (
          <>
            <p>
              Using the UWU-crvUSD market entails significant risk for 1- UWU
              token supply is concentrated in a few{" "}
              <PlainLink
                external
                href="https://etherscan.io/token/0x55C08ca52497e2f1534B59E2917BF524D4765257#balances"
              >
                wallets
              </PlainLink>
              , 2- UWU DEX liquidity is provided by few{" "}
              <PlainLink
                external
                href="https://debank.com/protocols/pool/0x0a7b2a21027f92243c5e5e777aa30bb7969b0188/eth/holders"
              >
                liquidity providers
              </PlainLink>{" "}
              (LPs). LPs can remove liquidity to prevent liquidations and
              manipulate UWU price upward to borrow more than the system allows.
            </p>

            <p>Silo Finance cannot protect you from risk. Do your research. </p>
          </>
        ))
        .with("ezEth-dex", () => (
          <>
            <p className="font-bold">
              ezETH DEX liquidity on Arbitrum is limited.
            </p>

            <p>
              In the unlikely event that PT-ezETH value drops significantly or
              ezETH de-pegs downward, liquidations might fail and ETH lenders
              might suffer bad debt. Use at your own risk.
            </p>
          </>
        ))
        .exhaustive()}
    </div>
  );
}
